import { getLocale } from 'umi';
import type { LocaleType, PlaceholderType } from '../types';

export const quarterPlaceholder: PlaceholderType = {
  'en-US': 'Quarter',
  'zh-CN': 'Quarter',
};
export const projectIdPlaceholder: PlaceholderType = {
  'en-US': 'P-team/BO/Studio/Project',
  'zh-CN': 'P-team/BO/Studio/Project',
};
export const platformPlaceholder: PlaceholderType = {
  'en-US': 'Platform',
  'zh-CN': 'Platform',
};
export const milestonePlaceholder: PlaceholderType = {
  'en-US': 'Milestone',
  'zh-CN': 'Milestone',
};
export const publisherPlaceholder: PlaceholderType = {
  'en-US': 'Publisher',
  'zh-CN': 'Publisher',
};
export const statusPlaceholder: PlaceholderType = {
  'en-US': 'Status',
  'zh-CN': 'Status',
};
export const stagePlaceholder: PlaceholderType = {
  'en-US': 'Stage',
  'zh-CN': 'Stage',
};
export const nextMilestonePlaceholder: PlaceholderType = {
  'en-US': 'Next Milestone',
  'zh-CN': 'Next Milestone',
};
export const dueDatePlaceholder: PlaceholderType = {
  'en-US': 'DUE',
  'zh-CN': 'DUE',
};
export const gateReviewPlaceholder: PlaceholderType = {
  'en-US': 'Gate Review',
  'zh-CN': 'Gate Review',
};
export const ownerPlaceholder: PlaceholderType = {
  'en-US': 'Owner',
  'zh-CN': 'Owner',
};
export const datePlaceholder: PlaceholderType = {
  'en-US': 'Day',
  'zh-CN': 'Day',
};
export const weekPlaceholder: PlaceholderType = {
  'en-US': 'Week',
  'zh-CN': 'Week',
};
export const monthPlaceholder: PlaceholderType = {
  'en-US': 'Month',
  'zh-CN': 'Month',
};
export const yearPlaceholder: PlaceholderType = {
  'en-US': 'Year',
  'zh-CN': 'Year',
};
export const tabPlaceholder: PlaceholderType = {
  'en-US': 'Tab',
  'zh-CN': 'Tab',
};
export const updateUserPlaceholder: PlaceholderType = {
  'en-US': 'Last Update',
  'zh-CN': 'Last Update',
};
export const priorityPlaceholder: PlaceholderType = {
  'en-US': 'Priority',
  'zh-CN': 'Priority',
};

export const dateTypeMap: any = {
  hourly: { 'en-US': 'By Hour', 'zh-CN': '按小时' },
  daily: { 'en-US': 'By Day', 'zh-CN': '按日' },
  weekly: { 'en-US': 'By Week', 'zh-CN': '按周' },
  monthly: { 'en-US': 'By Month', 'zh-CN': '按月' },
  year: { 'en-US': 'By Year', 'zh-CN': '按年' },
};

export const placeholderMap = {
  quarter: quarterPlaceholder,
  project_id: projectIdPlaceholder,
  platform: platformPlaceholder,
  milestone: milestonePlaceholder,
  publisher: publisherPlaceholder,
  status: statusPlaceholder,
  stage: stagePlaceholder,
  next_milestone: nextMilestonePlaceholder,
  dueDate: dueDatePlaceholder,
  gate_review: gateReviewPlaceholder,
  owner: ownerPlaceholder,
  date: datePlaceholder,
  week: weekPlaceholder,
  month: monthPlaceholder,
  year: yearPlaceholder,
  tab: tabPlaceholder,
  update_user: updateUserPlaceholder,
  priority: priorityPlaceholder,
} as any;

export function getPlaceholderText(key: string, lang: LocaleType = getLocale()) {
  return placeholderMap[key]?.[lang];
}
